import { render, staticRenderFns } from "./FundMixPage.vue?vue&type=template&id=512ba078"
import script from "./FundMixPage.vue?vue&type=script&lang=ts"
export * from "./FundMixPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports